document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.hair-concerns').forEach(function (section) {
    var list = section.querySelector('[data-hc-list]');
    var nav = section.querySelector('[data-hc-nav]');
    var prevBtn = section.querySelector('[data-hc-prev]');
    var nextBtn = section.querySelector('[data-hc-next]');

    if (!list) return;

    // Guards against layout thrashing from rapid resize/scroll events.
    var rafId = null;
    function schedule(fn) {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(fn);
    }

    function hasOverflow() {
      // 1px tolerance for sub-pixel rounding.
      return list.scrollWidth - list.clientWidth > 1;
    }

    function updateNavVisibility() {
      var overflowing = hasOverflow();

      list.classList.toggle('is-scrollable', overflowing);

      if (!nav) return;

      if (overflowing) {
        nav.hidden = false;
      } else {
        nav.hidden = true;
      }
    }

    function updateButtonStates() {
      if (!nav || nav.hidden) return;
      var maxScroll = list.scrollWidth - list.clientWidth - 1;
      if (prevBtn) prevBtn.disabled = list.scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = list.scrollLeft >= maxScroll;
    }

    function refresh() {
      updateNavVisibility();
      updateButtonStates();
    }

    // Move by one full "page" (however many items fit in view). Scroll-snap
    // takes care of aligning to the nearest item, so this never stops
    // mid-item even if clientWidth isn't an exact multiple of item width.
    function scrollByPage(direction) {
      list.scrollBy({ left: direction * list.clientWidth, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByPage(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByPage(1);
      });
    }

    list.addEventListener('scroll', function () {
      schedule(updateButtonStates);
    }, { passive: true });

    window.addEventListener('resize', function () {
      schedule(refresh);
    });

    // Catches theme-editor block add/remove/reorder and image loads that
    // change scrollWidth after the initial paint.
    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(function () {
        schedule(refresh);
      });
      observer.observe(list);
    }

    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        if (event.target.contains(section)) schedule(refresh);
      });
      document.addEventListener('shopify:block:select', function (event) {
        if (event.target.contains(section)) schedule(refresh);
      });
    }

    refresh();
  });
});